import React, { useState } from "react";
import { ScrollArea } from "../../../../components/ui";
import { resizeImage } from "../../../../util";
import { FaPlus, FaSearchPlus } from "react-icons/fa";
import { SlipLightboxModal } from "./SlipLightboxModal";

export const OrderSlips = ({ order, callApi, toastSuccess, toastError }) => {
  const [loading, setLoading] = useState(false);
  const [activeSlipModal, setActiveSlipModal] = useState(null);

  const uploadSlip = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const base64 = await resizeImage(file);
    if (!base64) {
      alert("อัพโหลด ได้เฉพาะ ไฟล์รูปภาพ นามสกุล jpg หรือ png");
      return;
    }

    setLoading(true);
    try {
      const result = await callApi(
        "orders-edit",
        { id: order.id, key: "slips", value: { fileName: file.name, base64 } },
        { notShowLoading: true },
      );
      if (result.status) {
        toastSuccess();
      } else {
        toastError(result.message);
      }
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const slips = order?.slips || [];

  return (
    <div>
      <input
        id="slip-upload"
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        className="hidden"
        onChange={uploadSlip}
      />

      <div className="flex items-center justify-between gap-3 pb-3 mb-3 border-b border-slate-200">
        <h4 className="font-bold text-lg text-slate-800">สลิปการโอน</h4>
        <label
          htmlFor="slip-upload"
          className={`bg-blue hover:opacity-90 text-white font-bold py-1.5 px-3 rounded-md text-xs flex items-center gap-1.5 transition-all shadow-xs ${
            loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          {loading ? (
            <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <FaPlus className="text-[10px]" />
              <span>อัปโหลดสลิป</span>
            </>
          )}
        </label>
      </div>

      {slips.length > 0 ? (
        <ScrollArea className="h-[480px]">
          <div className="flex flex-col gap-3 pr-3">
            {[...slips].reverse().map((slip, idx) => (
              <div
                key={slip || idx}
                className="group relative rounded-md border border-slate-200 overflow-hidden shadow-xs hover:shadow-md transition-shadow cursor-pointer bg-white"
                onClick={() => setActiveSlipModal(slip)}
              >
                <div className="absolute inset-0 bg-slate-900/30 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                  <span className="bg-slate-900/80 text-white text-xs font-bold py-1.5 px-3 rounded-md flex items-center gap-1.5 shadow-sm">
                    <FaSearchPlus /> คลิกเพื่อซูมและตรวจสอบ
                  </span>
                </div>
                <img
                  src={slip}
                  alt={`slip-${idx}`}
                  className="w-full h-auto max-h-[460px] object-contain mx-auto"
                />
              </div>
            ))}
          </div>
        </ScrollArea>
      ) : (
        <div className="h-44 flex flex-col justify-center items-center rounded-md border border-dashed border-slate-200 bg-slate-50/50">
          <p className="text-sm font-semibold text-slate-400">
            ไม่พบรูปภาพสลิป
          </p>
        </div>
      )}

      {/* Slip Zoom & Lightbox Modal */}
      <SlipLightboxModal
        isOpen={Boolean(activeSlipModal)}
        slipUrl={activeSlipModal}
        onClose={() => setActiveSlipModal(null)}
      />
    </div>
  );
};
